function initPaginationDots() {
  const paginationWrappers = document.querySelectorAll('.bh-pagination-wrapper');

  paginationWrappers.forEach(wrapper => {
    const listTag = wrapper.dataset.listTag;
    const itemTag = wrapper.dataset.itemTag;

    if (!listTag || !itemTag) return;

    const list = document.querySelector(`[${listTag}]`);
    const items = document.querySelectorAll(`[${itemTag}]`);
    const dotWrappers = wrapper.querySelectorAll('.pagination-dot-wrapper');

    if (!list || items.length === 0) return;

    function updateActiveDot() {
      const scrollLeft = list.scrollLeft;
      const listWidth = list.offsetWidth;
      const scrollCenter = scrollLeft + listWidth / 2;

      let activeIndex = 0;
      let minDistance = Infinity;

      items.forEach((item, index) => {
        const itemLeft = item.offsetLeft;
        const itemCenter = itemLeft + item.offsetWidth / 2;
        const distance = Math.abs(scrollCenter - itemCenter);

        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      dotWrappers.forEach((dotWrapper, index) => {
        dotWrapper.classList.toggle('active', index === activeIndex);
      });
    }

    list.addEventListener('scroll', updateActiveDot);

    dotWrappers.forEach(dotWrapper => {
      dotWrapper.addEventListener('click', () => {
        const index = parseInt(dotWrapper.dataset.index);
        const item = items[index];
        if (item) {
          const itemLeft = item.offsetLeft;
          const itemWidth = item.offsetWidth;
          const listWidth = list.offsetWidth;
          const scrollTo = itemLeft - (listWidth / 2) + (itemWidth / 2);
          
          list.scrollTo({ left: scrollTo, behavior: 'smooth' });
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", initPaginationDots);